module.exports = __webpack_public_path__ + "static/media/icons.9729d897.svg";